import apiService from "./apiService";
import {ADMIN_USERS_ITEMS_PER_PAGE} from "../../../pages/user/constants";


export const loggingInUser = (data) => {
  return apiService.post(URIS.login, data);
};

export const logOutUser = (refresh) => {
  return apiService.post(URIS.logout, {"refresh_token": refresh});
};

export const getAdminUsers = (page = 1, adminUsers = false) => {
  let params = {
    page,
    item_per_page: ADMIN_USERS_ITEMS_PER_PAGE,
    admin: adminUsers
  };
  return apiService.get(URIS.users, {params});
};

export const getAdminFeatures = () => {
  return apiService.get(URIS.features);
};

export const getAdminPermissions = () => {
  return apiService.get(URIS.permissions);
};

export const getUserProfile = () => {
  return apiService.get(URIS.profile);
};

export const postAdminUsers = (data) => {
  return apiService.post(URIS.users, data);
};

export const postAdminFeature = (data) => {
  return apiService.post(URIS.features, data);
};

export const postFeaturesToUsers = (userId, featureIds) => {
  return apiService.post(URIS_D('user_features', userId), {features: featureIds});
};

export const postPermissionsToFeatures = (featureId, permissionIds) => {
  return apiService.post(URIS_D('features_permissions', featureId), {permissions: permissionIds});
};

export const patchUpdateUsersPassword = (data) => {
  return apiService.patch(URIS.change_password, data);
};

export const putFeaturesToUsers = (userId, featureIds) => {
  return apiService.put(URIS_D('user_features', userId), {features: featureIds});
};

export const deleteFeaturesFromUsers = (userId, featureId) => {
  return apiService.delete(URIS_D('user_feature', userId, featureId));
};

export const deleteFeature = (featureId) => {
  return apiService.delete(URIS_D('feature', featureId));
};

export const putAdminUsers = (id, data) => {
  // return apiService.put(URIS_D('user', id),{...data, staff: true});
  return apiService.put(URIS_D('user', id), data);
};

export const putAdminFeature = (id, data) => {
  return apiService.put(URIS_D('feature', id), data);
};

export const postOrPutAdminUsers = (id, data) => {
  return id ? putAdminUsers(id, data) : postAdminUsers(data);
};

export const postOrPutAdminFeatures = (id, data) => {
  return id ? putAdminFeature(id, data) : postAdminFeature(data);
};

export const putProfile = (data) => {
  return apiService.put(URIS.profile, data);
};


const URIS_D = (url, param1, param2) => {
  return {
    user: `/v1/uam/users/${param1}`,
    user_features: `/v1/uam/users/${param1}/features`,
    user_feature: `/v1/uam/users/${param1}/features/${param2}`,
    features_permissions: `/v1/uam/features/${param1}/permissions`,
    feature: `/v1/uam/features/${param1}`
  }[url];
};

const URIS = {
  login: '/v1/uam/login',
  logout: '/v1/uam/logout',
  users: '/v1/uam/users',
  features: '/v1/uam/features',
  permissions: '/v1/uam/permissions',
  profile: '/v1/uam/profile',
  change_password: '/v1/uam/change_password'
};
